<template>
	<section class="Login0006">
		<el-row :gutter="12">
			<el-col class="inner__div">
				<el-card shadow="never" radius>
					<div class="Logo">
						<img src="../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
						<!-- 2021/02/06 #10499 START -->
						<!-- <h3>LOGIN</h3> -->
						<h3></h3>
						<!-- 2021/02/06 #10499 END -->
						<el-alert v-if="this.getElAdminAlert != null && this.getElAdminAlert.trim() != '' "
							:title="this.getElAdminAlert"
							type="error"
							effect="dark"
							:closable="false"
							class="toastAlert">
						</el-alert>
					</div>
					<div class="Form__div">
						<el-form
							ref="form"
							:rules="rules"
							:model="LoginForm"
							label-width="auto"
							class="form__items">
							<el-form-item label="企業コード" prop="contract">
								<el-input v-model="LoginForm.contract" placeholder></el-input>
							</el-form-item>

							<el-form-item label="ユーザーID" prop="user">
								<el-input v-model="LoginForm.user" placeholder></el-input>
							</el-form-item>

							<el-form-item label="パスワード" prop="pass">
								<el-input
									v-model="LoginForm.pass"
									type="password"
									placeholder
								></el-input>
							</el-form-item>
						</el-form>
					</div>

					<div class="retain__login">
						<el-checkbox v-model="checked">
							<h5 class="retain__login__label">ログイン状態を保持する</h5>
						</el-checkbox>
					</div>

					<div class="Login__btn">
						<el-button
							type="primary"
							@click="submitForm('form')"
							v-loading.fullscreen.lock="fullscreenLoading"
							plain
							class="op"
							>ログイン</el-button>
					</div>

					<div class="forgot__password">
						<!--// 2022/07/26  #13298  START -->
						<el-link
							type="primary"
							@click="ForgetClick"
							:underline="false"
							class="link"
							>パスワードの再設定はこちらから</el-link>
						<!--// 2022/07/26  #13298  END -->
					</div>
					<!--// 2022/07/26  #13298  START -->
					<div class="labelDiv">
						<label>ログインＩＤを皆様で共有されているタイプは、こちらからパスワードの再設定はできません。担当者までお問合せください。 </label>
					</div>
					<!--// 2022/07/26  #13298  END -->
				</el-card>
			</el-col>
		</el-row>
	</section>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import router from "../../router";
import Common from "../../common/CommonFunc.js";
export default {
	name: "Login0006",
	props: [],
	data() {
		var confirmCompanyCodeLength = (rule, value, callback) => {
			var companyCodeCheck = this.LoginForm.contract;
			if (companyCodeCheck.length > 12) {
				callback(new Error("Enter confirm password"));
			} else {
				callback();
			}
		};
		var confirmUserIDLength = (rule, value, callback) => {
			var userIDCheck = this.LoginForm.user;
			if (userIDCheck.length > 256) {
				callback(new Error("Enter confirm password"));
			} else {
				callback();
			}
		};
		var confirmPasswordLength = (rule, value, callback) => {
			var passwordCheck = this.LoginForm.pass;
			if (passwordCheck.length > 256) {
				callback(new Error("Enter confirm password"));
			} else {
				callback();
			}
		};
		
		return {
			fullscreenLoading: false,
			form: {
				name: "",
				name2: "",
				name3: "",
				region: "",
				date1: "",
				date2: "",
				delivery: false,
				type: [],
				resource: "",
				desc: ""
			},
			LoginForm: {
				contract: "",
				user: "",
				pass: ""
			},
			rules: {
				contract: [
					{
						required: true,
						type: "string",
						message: "企業コードを入力してください。"
					},
					{
						validator: confirmCompanyCodeLength,
						message: "企業コードは12文字以下を入力してください。"
					},
					{
						pattern: /^[/a-zA-Z0-9-!#$%^&*()_+|~=`{}[\]:";'<>?,. @]+$/,
						message: "企業コードは半角英数字を入力してください。"
					},
					{
						pattern: /^[/\u30ff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9]+$/,
						message: "企業コードは記号を入力できません。"
					}
				],
				user: [
					{
						required: true,
						type: "string",
						message: "ユーザーIDを入力してください。"
					},
					{
						validator: confirmUserIDLength,
						message: "ユーザーIDは256文字以下を入力してください。"
					},
					{
						//pattern: /^[/a-zA-Z0-9]+$/,
						pattern:/^[/\u30ff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9-!#$%^&*()_+|~=`{}[\]:";'<>?,.@]+$/,
						message: "ユーザーIDは半角英数字を入力してください。"
					}
				],
				pass: [
					{ required: true, message: "パスワードを入力してください。" },
					{
						validator: confirmPasswordLength,
						message: "パスワードは256文字以下を入力してください。"
					},
					{
						//pattern: /^[/a-zA-Z0-9]+$/,
						pattern:/^[/\u30ff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9-!#$%^&*()_+|~=`{}[\]:";'<>?,.@]+$/,
						message: "パスワードは半角英数字を入力してください。"
					}
				]
			},
			checked: ""
		};
	},

	methods: {
		ForgetClick() {
			this.$LogButtonEvent("0006","ForgotPassword");
			this.$LogMethodIN("0006","ForgetClick");
			var credentials = {
				contract_code: this.LoginForm.contract,
				user_id: this.LoginForm.user
			};
			router.push({
				name: "sp_0022",
				params: {
					credentials: credentials
				}
			});
			this.$LogMethodOut("0006","ForgetClick");
		},
		submitForm(formName) {
      if (this.fullscreenLoading) {
        return
      }
      this.fullscreenLoading = true
      
			this.$LogButtonEvent("0006","Submit");
			this.$LogMethodIN("0006","submitForm");

			Common.General.SetLocalStorage("ip_authenicate_user", false);

			//for the login page validation
			this.$refs[formName].validate(valid => {
				if (valid) {
					var credentials = "";
					if (this.checked == false) {
						credentials = {
							contract_code: this.LoginForm.contract,
							user_id: this.LoginForm.user,
							password: this.LoginForm.pass,
							Remember_me: false
						};
					} else {
						credentials = {
							contract_code: this.LoginForm.contract,
							user_id: this.LoginForm.user,
							password: this.LoginForm.pass,
							Remember_me: true
						};
					} 

					Vue.prototype.$session.set("contract_code", this.LoginForm.contract);

					Vue.prototype.$session.set('themeNewsCountForMobileSorting',this.getThemeNewsCount);
    Vue.prototype.$session.set('themeWebNewsCountForMobileSorting',this.getThemeWebCount);

					this.$store
						.dispatch("sp_Communication0006/login", { credentials })
						.then(() => {
							this.fullscreenLoading = true;
						
							var errorMessage = this.getErrorMessage;
							var msgcode = this.getResponseMessageCode;
							this.fullscreenLoading = false;
							
							if (errorMessage == 0 && this.getResponseMessage !='') {
								this.fullscreenLoading = false;
								this.$alert(this.getResponseMessage, "ログイン", {
									confirmButtonText: "OK"
								});
							}
							if(msgcode == "MSG0005")
							{
								/*** Change by SJ for backlog Id: 1645 */
								router.push('/sp/0001');
							}													
							console.log(this.getModeCheck)
							if(this.getModeCheck != ''){
								console.log("ModeCHECK")
								var pdfValues = this.getModeCheck
								var pdf_flag = pdfValues.pdf_flag;
								if(pdf_flag === 1){
									var pdfDisplayRequestLog = this.getModeCheckRequests
									var pdfCombinedArray = [];
									pdfCombinedArray.push(pdfValues)
									pdfCombinedArray.push(pdfDisplayRequestLog)
									console.log(pdfCombinedArray)
									//Currently only for pdfDisplay is implemented
									this.$store.dispatch("sp_Communication0004/checkPdfDisplay", pdfCombinedArray).then(()=> {
										this.fullscreenLoading = false;
										//router.push('/0002');

									});
								}
								
							}
						})
						.catch((err) => {
							console.log(err);
							// this.$alert(this.getResponseMessage, "ログイン", {
							// 	confirmButtonText: "OK"
							// });
							this.fullscreenLoading = false;
						});
				} 
				else 
				{
					this.fullscreenLoading = false;
					return false;
				}
			});
			this.$LogMethodOut("0006","submitForm");
		}
	},
	computed: {
		...mapGetters("sp_Situation0006", [
			"getElAdminAlert",
			"getResponseMessage",
			"getResponseMessageCode",
			"getErrorMessage"
		]),
		...mapGetters("sp_ValidationHandler", ["getRules"]),
		...mapGetters("situation0001", [		
			"getModeCheck",
			"getModeCheckRequests"
		])
	},
	//called after all the DOM elements has been mounted
	mounted() {
		/*** Worked by AJ for backlog Id: 1314 */
		//Code for set the previously entered Company Code value
		var UserContractCode = Common.General.GetLocalStorage('Contract_code');
		
		if(UserContractCode != '' && UserContractCode != null && UserContractCode != undefined)
		{
			this.LoginForm.contract = UserContractCode;
		}
		/*** Worked by AJ for backlog Id: 1314 */	
		//Get table Alert Message during page load
		this.$store.dispatch("sp_Communication0006/getElAlert");
		if (this.$route.query.ip == 1) {
			this.$store.dispatch("sp_Communication0021/IpCheckingResponse");
		}
	},
	created() {
		//Common.Session.CheckIsMobile("/sp/0001", "/0001"); // MobileScreen Path, WebScreen Path
	}
};
</script>

<style scoped>
@import "0006.css";
@import "../../assets/css/customStyle.css";
</style>
